// extracted by mini-css-extract-plugin
export default {"container":"PaymentIFrame_container__hjhB2","hpp_iframe":"PaymentIFrame_hpp_iframe__tj8n0"};